export default __webpack_public_path__ + "static/engagement-dark-b784d5794ad3df6a076aced51a0219f6.png";